import { StyleSheet } from "react-native"
import { Colors, Spacing } from "@constants"
import { HEADER_HEIGHT } from "@atomic/organisms/Header"

export const createStyles = (isMobile: boolean) =>
  StyleSheet.create({
    backGroundImage: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: -1,
    },
    container: {
      backgroundColor: Colors.background2,
      width: "100%",
      paddingTop: HEADER_HEIGHT + Spacing.XXL,
      paddingBottom: "15%",
      flex: 1,
      alignItems: "center",
    },
    contentContainer: {
      flex: 1,
      alignItems: "center",
      maxWidth: isMobile ? "100%" : 600,
      paddingHorizontal: 20,
    },
    welcomeTitle: {
      fontSize: 32,
      fontWeight: "bold",
      color: Colors.foodiBlack,
      textAlign: "center",
      marginBottom: 40,
    },
    mainCard: {
      width: "100%",
      borderWidth: 1,
      borderColor: Colors.lightGray,
      borderRadius: 12,
      padding: isMobile ? 12 : 24,
      marginBottom: 24,
      backgroundColor: Colors.white,
      alignItems: "center",
    },
    sectionHeader: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 8,
    },
    sectionIcon: {
      marginRight: 8,
      color: Colors.foodiBlack,
    },
    sectionTitle: {
      fontSize: 18,
      fontWeight: "bold",
      color: Colors.foodiBlack,
    },
    sectionSubtitle: {
      fontSize: 14,
      color: Colors.gray1,
      marginBottom: 24,
      lineHeight: 20,
      textAlign: "center",
    },
    inputsContainer: {
      marginBottom: 24,
      width: "100%",
      alignItems: "center",
    },
    checkboxContainer: {
      marginBottom: 24,
      width: "100%",
      alignItems: "flex-start",
    },
    validationText: {
      fontSize: 12,
      color: Colors.redError,
      textAlign: "center",
      marginBottom: 16,
      fontStyle: "italic",
      lineHeight: 16,
    },
    mandatoryTextInCard: {
      fontSize: 12,
      color: Colors.gray1,
      textAlign: "center",
      marginTop: 12,
      fontStyle: "italic",
    },
    buttonContainer: {
      marginTop: 20,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    finishButton: {
      paddingVertical: 16,
      paddingHorizontal: isMobile ? 4 : 24,
      borderRadius: 8,
      backgroundColor: Colors.foodiDefault,
      alignItems: "center",
      justifyContent: "center",
    },
    buttonText: {
      fontSize: 16,
      fontWeight: "600",
      color: Colors.foodiBlack,
    },
    infoBoxTitleRow: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
    },
    infoBoxTitle: {
      fontSize: 16,
      fontWeight: "600",
      color: Colors.foodiBlack,
    },
    infoBoxTime: {
      fontSize: 14,
      color: Colors.gray1,
    },
    infoBoxText: {
      fontSize: 14,
      color: Colors.foodiBlack,
      lineHeight: 20,
      textAlign: "center",
    },
    linkText: {
      color: Colors.blueLink,
      textDecorationLine: "underline",
    },
    privacyText: {
      fontSize: 12,
      color: Colors.foodiBlack,
      textAlign: "center",
    },
    supportText: {
      fontSize: 12,
      color: Colors.foodiBlack,
      textAlign: "center",
      marginTop: 10,
    },
  })
